import api, { publicApi } from "./api";

// =========================
// PUBLIC (registration)
// =========================
export const getPostalCodes = async () => {
    const res = await publicApi.get("/postalcode");
    return res.data;
};

export const getPostalCodesByCity = async (cityId) => {
    const res = await publicApi.get(`/postalcode/city/${cityId}`);
    return res.data;
};

export const getPostalCodeById = async (id) => {
    const res = await publicApi.get(`/postalcode/${id}`);
    return res.data;
};

// =========================
// ADMIN (CRUD)
// =========================
export const createPostalCode = async (data) => {
    const res = await api.post("/postalcode", data);
    return res.data;
};

export const updatePostalCode = async (id, data) => {
    const res = await api.put(`/postalcode/${id}`, data);
    return res.data;
};

export const deletePostalCode = async (id) => {
    const res = await api.delete(`/postalcode/${id}`);
    return res.data;
};
